module.exports = __webpack_public_path__ + "img/BAT-alt.e21385ae.svg";